import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-122" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-123" data-mp="9tl66pubh5qm">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-ivory rounded-3xl border border-line p-8 shadow-card sm:p-12" data-id="element-124" data-mp="et66p4p4xm5g">
          <span className="inline-flex rounded-full border border-teal/20 bg-aquaSoft p-4 text-teal" data-id="element-125" data-mp="skcbngb6obzq">
            <ShieldCheckIcon className="h-10 w-10" data-id="element-126" data-mp="xkgsj7g078qh" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-127" data-mp="xlrvx65jeeh2">Garantía de 7 días, sin preguntas</h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-128" data-mp="17hli7h925mc1">
            Abrís los tomos. Los usás en el museo y en el aula. Si en 7 días no es lo que esperabas, solicitás tu devolución.
          </p>
          <p className="mt-6 rounded-xl border border-teal/20 bg-aquaSoft px-5 py-4 text-lg font-extrabold text-teal" data-id="element-129" data-mp="20t3xj0dzvd1g">
            Devolución del 100% sin formularios, sin drama.
          </p>
          <p className="mt-5 text-xs font-bold uppercase tracking-[.14em] text-muted" data-id="element-130" data-mp="1rsfetsdnooi8">Tasa de devoluciones: menos del 1%</p>
        </motion.div>
      </div>
    </section>;
}